import { render, staticRenderFns } from "./settings-1.vue?vue&type=template&id=37955acc&"
import script from "./settings-1.vue?vue&type=script&lang=js&"
export * from "./settings-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports